/* Copyright 2014-2018 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/registry",
    "./constants/TypeConstants",
    "./managers/ModelManager",
    "./managers/WidgetManager",
    "./supportedUIBuilderFunctions"
], function (declare, lang, registry, TypeConstants, ModelManager, WidgetManager, supportedUIBuilderFunctions) {

    return declare(null, {

        constructor: function (args) {
            var modelManager, widgetManager;

            modelManager = new ModelManager(args);
            widgetManager = new WidgetManager({
                modelManager: modelManager
            });

            supportedUIBuilderFunctions.fromModelManager.forEach(function (func) {
                this[func] = lang.hitch(modelManager, modelManager[func]);
            }, this);

            supportedUIBuilderFunctions.fromWidgetManager.forEach(function (func) {
                this[func] = lang.hitch(widgetManager, widgetManager[func]);
            }, this);

            this.cleanup = function () {
                modelManager.cleanup();
                widgetManager.cleanup();
            };

            if (args.manageTabGroupsOutsidePeerModel) {

                this.add = function (childId, parentId, index) {
                    var childNode = modelManager.manager.getById(childId);
                    if (childNode && childNode.getType() === TypeConstants.TAB_GROUP) {
                        widgetManager.addOutsidePeerModel(childId, parentId);
                        // TODO: Also add corresponding QAB group
                    } else {
                        modelManager.add(childId, parentId, index);
                    }
                };

                this.remove = function (childId) {
                    var childNode = modelManager.manager.getById(childId);
                    if (childNode && childNode.getType() === TypeConstants.TAB_GROUP) {
                        widgetManager.removeOutsidePeerModel(childId);
                        // TODO: Also remove corresponding QAB group
                    } else {
                        modelManager.remove(childId);
                    }
                };

                this.get = function (id, propertyName) {
                    if (propertyName === "selectedTab" && modelManager.manager.getById(id).getType() === TypeConstants.TOOLSTRIP) {
                        var toolstrip = registry.byId(id);
                        return toolstrip ? toolstrip.get(propertyName) : "";
                    } else {
                        return modelManager.get(id, propertyName);
                    }
                };

                this.set = function (id, propertyName, value) {
                    if (propertyName === "selectedTab" && modelManager.manager.getById(id).getType() === TypeConstants.TOOLSTRIP) {
                        var toolstrip = registry.byId(id);
                        if (toolstrip) {
                            toolstrip.set(propertyName, value);
                        }
                    } else {
                        return modelManager.set(id, propertyName, value);
                    }
                };

                this.getChildrenIds = function (id) {
                    if (modelManager.manager.getById(id).getType() === TypeConstants.TOOLSTRIP) {
                        var toolstrip = registry.byId(id);
                        var tabGroups = toolstrip.getChildren();
                        var childIds = [];
                        childIds.length = tabGroups.length;
                        for (var i = 0; i < childIds.length; i++) {
                            childIds[i] = tabGroups[i].id;
                        }
                        return childIds;
                    } else {
                        return modelManager.getChildrenIds(id);
                    }
                };

                this.isAnOrphan = function (id) {
                    if (modelManager.manager.getById(id).getType() === TypeConstants.TAB) {
                        // Return true if tab widget exists and owning tab group is on the toolstrip
                        var tab = registry.byId(id);
                        return !(tab && tab.getParent() && tab.getParent().getParent());
                    } else {
                        return modelManager.isAnOrphan(id);
                    }
                };

                this.selectFirstTabInTabGroup  = function (tabGroupTag, toolstripId) {
                    var tabGroupId = modelManager.tagToPeerNodeIdMap[tabGroupTag];
                    if (tabGroupId) {
                        var tabGroupNode = modelManager.manager.getById(tabGroupId);
                        if (tabGroupNode && tabGroupNode.getChildren().length > 0) {
                            var toolstrip = registry.byId(toolstripId);
                            if (toolstrip) {
                                toolstrip.set("selectedTab", "");
                                toolstrip.set("selectedTab", tabGroupNode.getChildren()[0].getId());
                            }
                        }
                    }
                };

                this.addPropertySetCallback = function (id, callback, scope) {
                    if (modelManager.manager.getById(id).getType() === TypeConstants.TOOLSTRIP) {
                        var toolstrip = registry.byId(id);
                        if (toolstrip) {
                            return toolstrip.watch(function (name, oldValue, newValue) {
                                callback({property: name,
                                          oldValue: oldValue,
                                          newValue: newValue});
                            });
                        }
                        return null;
                    } else {
                        return modelManager.addPropertySetCallback(id, callback, scope);
                    }
                };
            }
        }
    });
});